import { ptax } from '@/proto/proto';
import { Tag } from 'antd';
import { nameOf } from '@/components/covalent/tax/change/TaxChangeType';

type TaxNoticeChangeTypeTextProps = {
  data?: ptax.IPbTaxNotice;
};

const TaxNoticeChangeTypeText = ({ data }: TaxNoticeChangeTypeTextProps) => {
  return <Tag style={{ margin: 0 }}>{nameOf(Number(data?.changeRequest?.first()?.typeCode ?? -1))}</Tag>;
};

TaxNoticeChangeTypeText.defaultProps = {
  data: undefined,
};

export default TaxNoticeChangeTypeText;
